var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckOn = function SvgCheckOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 4,
    fill: "#2A609D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.494 7.436a.75.75 0 0 1 .07 1.058l-7 8a.75.75 0 0 1-1.094.036l-3-3a.75.75 0 1 1 1.06-1.06l2.433 2.433 6.473-7.397a.75.75 0 0 1 1.058-.07Z",
    fill: "#fff"
  })));
};
export { SvgCheckOn as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHg9IjIiIHk9IjIiIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgcng9IjQiIGZpbGw9IiMyQTYwOUQiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNy40OTM5IDcuNDM1NThDMTcuODA1NiA3LjcwODM0IDE3LjgzNzIgOC4xODIxNiAxNy41NjQ0IDguNDkzODlMMTAuNTY0NCAxNi40OTM5QzEwLjQyNzcgMTYuNjUwMSAxMC4yMzI0IDE2Ljc0MjcgMTAuMDI1IDE2Ljc0OTZDOS44MTc1IDE2Ljc1NjUgOS42MTY0NSAxNi42NzcxIDkuNDY5NjcgMTYuNTMwM0w2LjQ2OTY3IDEzLjUzMDNDNi4xNzY3OCAxMy4yMzc0IDYuMTc2NzggMTIuNzYyNiA2LjQ2OTY3IDEyLjQ2OTdDNi43NjI1NiAxMi4xNzY4IDcuMjM3NDQgMTIuMTc2OCA3LjUzMDMzIDEyLjQ2OTdMOS45NjM0NyAxNC45MDI4TDE2LjQzNTYgNy41MDYxM0MxNi43MDgzIDcuMTk0NCAxNy4xODIyIDcuMTYyODIgMTcuNDkzOSA3LjQzNTU4WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";